import React, { useCallback, useEffect, useState } from "react";
import styles from "./newView.module.css";
import axios from "axios";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import Loading from "../../../Components/Loading/Loading";
import RecordInfo from "../../../Components/RecordInfo/RecordInfo";
import ViewForm from "../../../Components/ViewForm/ViewForm";

function NewView() {
  // Utils
  const [initialLoading, setInitialLoading] = useState(false);

  // State
  const [currentStep, setCurrentStep] = useState(1);
  const [userDetails, setUserDetails] = useState({
    userName: "",
    date: null,
    site: "",
    worktime: "",
    payments: [],
  });
  // Relations
  const [availableViewTypes, setAvailableViewTypes] = useState([]);
  const [availableSites, setAvailableSites] = useState([]);
  const [availablePaymentMethods, setAvailablePaymentMethods] = useState([]);
  const [availableWorkTimes, setAvailableWorkTimes] = useState([]);
  const [availableDiscountReason, setAvailableDiscountReason] = useState([]);
  const [availableUsers, setAvailableUsers] = useState([]);
  const user = useSelector((state) => state.auth.user);
  const role = useSelector((state) => state.auth.role.roleName);
  
  const fetchData = useCallback(async () => {
    setInitialLoading(true);
    try {
      const [viewtype, paymentmethod, site, discountReason, worktime] =
        await Promise.all([
          axios.get(`${process.env.REACT_APP_API_URL}/viewType/`, {
            withCredentials: true,
          }),
          axios.get(`${process.env.REACT_APP_API_URL}/paymentmethod/`, {
            withCredentials: true,
          }),
          axios.get(
            `${process.env.REACT_APP_API_URL}/user/${user.userId}/sites`,
            {
              withCredentials: true,
            }
          ),
          axios.get(`${process.env.REACT_APP_API_URL}/discountreason/`, {
            withCredentials: true,
          }),
          axios.get(`${process.env.REACT_APP_API_URL}/worktime/`, {
            withCredentials: true,
          }),
        ]);

      setAvailableViewTypes(viewtype.data);
      setAvailablePaymentMethods(paymentmethod.data);
      setAvailableWorkTimes(worktime.data?.filter((t) => t.isHidden === false));
      setAvailableSites(site.data);
      setAvailableDiscountReason([
        ...discountReason.data,
        { reason: "سبب آخر" },
      ]);
      if (role === "Employee") {
        setAvailableUsers([
          {
            id: user.userId,
            name: user.userName,
          },
        ]);
      } else {
        const users = await axios.get(
          `${process.env.REACT_APP_API_URL}/user/all`,
          {
            withCredentials: true,
          }
        );
        setAvailableUsers(users.data);
      }
      setInitialLoading(false);
    } catch (error) {
      setInitialLoading(false);
      toast.error("An error occurred");
    }
  }, [user]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return initialLoading ? (
    <Loading />
  ) : (
    <div className={styles.form}>
      {currentStep === 2 ? (
        <ViewForm
          userDetails={userDetails}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          availableDiscountReason={availableDiscountReason}
          availableViewTypes={availableViewTypes}
          availablePaymentMethods={availablePaymentMethods}
        />
      ) : (
        <RecordInfo
          users={availableUsers}
          role={role}
          payments={availablePaymentMethods}
          sites={availableSites}
          worktimes={[...availableWorkTimes, { duration: "غير ذلك" }]}
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          setUserDetails={setUserDetails}
        />
      )}
    </div>
  );
}

export default NewView;
